import React from "react";
import {
  Button,
  Form,
  Col,
  Row,
  InputGroup,
  FormControl,
  Modal,
} from "react-bootstrap";
import axios from "axios";
import "../asserts/css/development.css";
import "../asserts/css/style.css";
import $ from "jquery";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import "react-datepicker/dist/react-datepicker.css";
import ErrorsMessageToast from "./errorsMessageToast";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUpload,
  faDownload,
  faSave,
} from "@fortawesome/free-solid-svg-icons";
import * as publicUtils from "./utils/publicUtils.js";
import store from "./redux/store";
import MyToast from "./myToast";
import { notification, message } from "antd";
/**
 * 作業報告書登録画面
 */
class resume extends React.Component {
  constructor(props) {
    super(props);
    this.state = this.initialState; //初期化
    this.valueChange = this.valueChange.bind(this);
    this.searchResume = this.searchResume.bind(this);
  }
  componentDidMount() {
    $("#resumeDownload").attr("disabled", true);
    this.searchResume();
    this.searchEmployeeName();
  }
  //onchange
  valueChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };
  //　初期化データ
  initialState = {
    employeeList: [],
    serverIP: store.getState().dropDown[store.getState().dropDown.length - 1],
  };
  //　検索
  searchResume = () => {
    axios
      .post(this.state.serverIP + "resume/selectResume")
      .then((response) => response.data)
      .then((data) => {
        //data.push({ "rowNo": 2, "resumeInfo1": data[0].resumeInfo2, "resumeName1": data[0].resumeName2, "updateTime": data[0].updateTime, "updateUser": data[0].updateUser });
        if (data[0]?.resumeInfo1 == null || data[0]?.resumeInfo1 == "") {
          data[0]["fileSts"] = false;
        } else {
          data[0]["fileSts"] = true;
        }
        if (data[0]?.resumeInfo2 == null || data[0]?.resumeInfo2 == "") {
          data[1]["fileSts"] = false;
        } else {
          data[1]["fileSts"] = true;
        }
        this.setState({
          employeeList: data,
          haveChange: false,
        });
      });
  };
  searchEmployeeName = () => {
    axios
      .post(this.state.serverIP + "resume/selectEmployeeName")
      .then((response) => {
        this.setState({
          employeeName: response.data.employeeName,
        });
      });
  };
  //　変更と追加
  InsertResume = (e) => {
    this.setState({ errorsMessageShow: false });
    var a = new RegExp("^" + this.state.employeeName + "_.");
    if (!this.state.haveChange) {
      this.setState({
        errorsMessageShow: true,
        method: "put",
        message: "変更ありません",
      });
      return;
    }
    if (
      !(
        this.state.employeeList[0].resumeInfo === undefined ||
        this.state.employeeList[0].resumeInfo === null ||
        this.state.employeeList[0].resumeInfo === ""
      )
    ) {
      if (
        this.state.employeeList[0].resumeName === undefined ||
        this.state.employeeList[0].resumeName === null ||
        this.state.employeeList[0].resumeName === ""
      ) {
        this.setState({
          errorsMessageShow: true,
          method: "put",
          message: "ファイル名を入力してください。",
        });
        return;
      }
    }

    if (
      !(
        this.state.employeeList[1].resumeInfo === undefined ||
        this.state.employeeList[1].resumeInfo === null ||
        this.state.employeeList[1].resumeInfo === ""
      )
    ) {
      if (
        this.state.employeeList[1].resumeName === undefined ||
        this.state.employeeList[1].resumeName === null ||
        this.state.employeeList[1].resumeName === ""
      ) {
        this.setState({
          errorsMessageShow: true,
          method: "put",
          message: "ファイル名を入力してください。",
        });
        return;
      }
    }

    if (
      this.state.employeeList[0].resumeName ===
      this.state.employeeList[1].resumeName
    ) {
      this.setState({
        errorsMessageShow: true,
        method: "put",
        message: "ファイル名が同じです",
      });
      return;
    }
    const formData = new FormData();
    const emp = {
      resumeInfo1: this.state.employeeList[0].resumeInfo,
      resumeInfo2: this.state.employeeList[1].resumeInfo,
      resumeName1: this.state.employeeList[0].resumeName,
      resumeName2: this.state.employeeList[1].resumeName,
    };
    formData.append("emp", JSON.stringify(emp));
    formData.append(
      "filePath1",
      publicUtils.nullToEmpty($("#filePath1").get(0).files[0])
    );
    formData.append(
      "filePath2",
      publicUtils.nullToEmpty($("#filePath2").get(0).files[0])
    );
    axios
      .post(this.state.serverIP + "resume/insertResume", formData)
      .then((response) => {
        if (response.data) {
          message.success("登録完了");
          this.searchResume();
          var file = document.getElementById("UpButtonForm1");
          file.reset();
          var file = document.getElementById("UpButtonForm2");
          file.reset();
        } else {
          message.error("登録失敗");
        }
      });
  };
  //行Selectファンクション
  handleRowSelect = (row, isSelected, e) => {
    if (isSelected) {
      if (row.fileSts || row.haveFile) {
        this.setState({
          rowSelectfileSts: true,
        });
      } else {
        this.setState({
          rowSelectfileSts: false,
        });
      }
    }
  };

  downloadResume = (resumeInfo, no, resumeName) => {
    let fileKey = "";
    let downLoadPath = "";
    if (resumeInfo !== null && resumeInfo.split("file/").length > 1) {
      fileKey = resumeInfo.split("file/")[1];
      downLoadPath = (
        resumeInfo.substring(0, resumeInfo.lastIndexOf("_") + 1) +
        resumeName.replace(this.state.employeeName + "_", "") +
        "." +
        resumeInfo.split(".")[resumeInfo.split(".").length - 1]
      ).replaceAll("/", "//");
    }
    axios
      .post(this.state.serverIP + "s3Controller/downloadFile", {
        fileKey: fileKey,
        downLoadPath: downLoadPath,
      })
      .then((result) => {
        let path = downLoadPath.replaceAll("//", "/");
        if (no === 1) {
          publicUtils.resumeDownload(
            path,
            this.state.serverIP,
            this.state.resumeName1
          );
        } else if (no === 2) {
          publicUtils.resumeDownload(
            path,
            this.state.serverIP,
            this.state.resumeName2
          );
        }
      })
      .catch(function (error) {
        notification.error({
          message: "エラー",
          description: "ファイルが存在しません。",
          placement: "topLeft",
        });
      });
  };

  setDownButton = (cell, row) => {
    return (
      <Button
        variant="info"
        size="sm"
        onClick={this.downloadResume.bind(
          this,
          row.resumeInfo,
          row.rowNo,
          row.resumeName
        )}
        id={"resumeDownload" + row.rowNo}
      >
        <FontAwesomeIcon icon={faDownload} />
        Download
      </Button>
    );
  };
  setUpButton = (cell, row) => {
    return (
      <form id={"UpButtonForm" + row.rowNo}>
        <Button size="sm" onClick={(event) => this.addFile(event, row.rowNo)}>
          <FontAwesomeIcon />
          {row.haveFile !== true ? " 添付" : " 添付済み"}{" "}
        </Button>
        <Form.File
          id={"filePath" + row.rowNo}
          hidden
          onChange={(event) => this.changeFile(event, row)}
        />
      </form>
    );
  };
  addFile = (event, name) => {
    $("#filePath" + name).click();
  };
  changeFile = (event, row) => {
    var filePath = event.target.value;
    if (filePath == "") {
      return;
    }
    var arr = filePath.split("\\");
    let fileName = filePath.split(".");
    if (
      fileName[fileName.length - 1] === "xlsx" ||
      fileName[fileName.length - 1] === "xls" ||
      fileName[fileName.length - 1] === "xltx" ||
      fileName[fileName.length - 1] === "xlt" ||
      fileName[fileName.length - 1] === "xlsm" ||
      fileName[fileName.length - 1] === "xlsb" ||
      fileName[fileName.length - 1] === "xltm" ||
      fileName[fileName.length - 1] === "csv" ||
      fileName[fileName.length - 1] === "pdf"
    ) {
    } else {
      message.error("PDF或いはexcelをアップロードしてください");
      var file = document.getElementById("UpButtonForm1");
      file.reset();
      var file = document.getElementById("UpButtonForm2");
      file.reset();
      return;
    }
    let data = this.state.employeeList;
    data[row.rowNo - 1]["filePath"] = filePath;
    data[row.rowNo - 1]["haveFile"] = true;
    if (!row.fileSts) {
      //data[row.rowNo - 1]["resumeInfo"] = this.state.employeeName+"_";
      data[row.rowNo - 1]["resumeName"] = this.state.employeeName + "_";
    }
    this.setState({
      employeeList: data,
      haveChange: true,
    });
  };

  setSts(cell, row) {
    if (row.resumeInfo !== "") {
      return "存在";
    } else {
      return "存在なし";
    }
  }
  setUpDate = (cell, row) => {
    return row.updateTime.substr(0, 16);
  };
  resumeNameChange = (event, cell, row) => {
    let data = this.state.employeeList;
    data[row.rowNo - 1][event.target.name] = event.target.value;
    this.setState({
      haveChange: true,
    });
  };
  getResumeName = (cell, row) => {
    let returnItem = cell;
    returnItem = (
      <span>
        <input
          type="text"
          class=" form-control editor edit-text"
          name="resumeName"
          maxLength="25"
          value={cell}
          onChange={(event) => this.resumeNameChange(event, cell, row)}
        />
      </span>
    );
    return returnItem;
  };
  render() {
    const { employeeList } = this.state;
    //　テーブルの行の選択
    const selectRow = {
      mode: "radio",
      bgColor: "pink",
      clickToSelectAndEditCell: true,
      hideSelectColumn: true,
      clickToExpand: true, // click to expand row, default is false
      onSelect: this.handleRowSelect,
    };
    //　 テーブルの定義
    const options = {
      hideSizePerPage: true, //> You can hide the dropdown for sizePerPage
      hidePageListOnlyOnePage: true,
      expandRowBgColor: "rgb(165, 165, 165)",
      approvalBtn: this.createCustomApprovalButton,
      onApprovalRow: this.onApprovalRow,
      handleConfirmApprovalRow: this.customConfirm,
    };
    const cellEdit = {
      mode: "click",
      blurToSave: true,
    };
    return (
      <div>
        <div style={{ display: this.state.myToastShow ? "block" : "none" }}>
          <MyToast
            myToastShow={this.state.myToastShow}
            message={this.state.message}
            type={"success"}
          />
        </div>
        <div
          style={{ display: this.state.errorsMessageShow ? "block" : "none" }}
        >
          <ErrorsMessageToast
            errorsMessageShow={this.state.errorsMessageShow}
            message={this.state.message}
            type={"danger"}
          />
        </div>
        <FormControl
          id="rowSelectCheckSection"
          name="rowSelectCheckSection"
          hidden
        />
        <Form>
          <div>
            <Form.Group>
              <Row inline="true">
                <Col className="text-center">
                  <h2>履歴書アップロード</h2>
                </Col>
              </Row>
            </Form.Group>
          </div>
        </Form>
        <div>
          <Form.File
            id="getFile"
            accept="application/pdf,application/vnd.ms-excel"
            custom
            hidden="hidden"
            onChange={this.resumeUpload}
          />
          <br />
          <Row>
            <Col sm={6}>
              <font style={{ whiteSpace: "nowrap" }}>履歴書</font>
            </Col>
            <Col sm={6}>
              <div style={{ textAlign: "right" }}>
                <Button
                  size="sm"
                  variant="info"
                  type="button"
                  onClick={this.InsertResume}
                  on
                >
                  <FontAwesomeIcon icon={faSave} /> {" 登録"}
                </Button>
              </div>
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <BootstrapTable
                pagination={true}
                data={employeeList}
                options={options}
                approvalRow
                selectRow={selectRow}
                headerStyle={{ background: "#5599FF" }}
                striped
                hover
                condensed
              >
                <TableHeaderColumn
                  dataField="filePath"
                  hidden
                ></TableHeaderColumn>
                <TableHeaderColumn
                  dataField="haveFile"
                  hidden
                ></TableHeaderColumn>
                <TableHeaderColumn
                  dataField="resumeInfo1"
                  hidden
                ></TableHeaderColumn>
                <TableHeaderColumn
                  width="5%"
                  tdStyle={{ padding: ".45em" }}
                  dataField="rowNo"
                  isKey
                >
                  番号
                </TableHeaderColumn>
                <TableHeaderColumn
                  width="15%"
                  tdStyle={{ padding: ".45em" }}
                  dataField="nodata"
                  dataFormat={this.setUpButton.bind(this)}
                >
                  添付状況
                </TableHeaderColumn>
                <TableHeaderColumn
                  width="15%"
                  tdStyle={{ padding: ".45em" }}
                  dataField="fileSts"
                  dataFormat={this.setSts}
                >
                  ファイルステータス
                </TableHeaderColumn>
                <TableHeaderColumn
                  width="25%"
                  tdStyle={{ padding: ".45em" }}
                  dataField="resumeName"
                  dataFormat={this.getResumeName}
                >
                  履歴書名
                </TableHeaderColumn>
                <TableHeaderColumn
                  width="20%"
                  tdStyle={{ padding: ".45em" }}
                  dataField="nodata"
                  dataFormat={this.setDownButton}
                >
                  履歴書DownLoad
                </TableHeaderColumn>
                <TableHeaderColumn
                  width="10%"
                  tdStyle={{ padding: ".45em" }}
                  dataField="updateUser"
                >
                  更新者
                </TableHeaderColumn>
                <TableHeaderColumn
                  width="15%"
                  tdStyle={{ padding: ".45em" }}
                  dataField="updateTime"
                  dataFormat={this.setUpDate.bind(this)}
                >
                  更新日
                </TableHeaderColumn>
              </BootstrapTable>
            </Col>
          </Row>
          <br />
        </div>
      </div>
    );
  }
}
export default resume;
